import { inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ApiLegalDocumentsCacheService } from './api-legal-documents-cache.service';

@Injectable({ providedIn: 'root' })
export class PreloadLegalDocumentsResolver implements Resolve<void> {
  protected readonly legalDocumentsCacheService = inject(ApiLegalDocumentsCacheService);

  public resolve(): void {
    this.legalDocumentsCacheService.preloadDocuments();

    return;
  }
}
